import { Link } from "react-router-dom";
import SharedLayout from "../components/SharedLayout";
import useSEO from "../utils/useSEO";

const GlowOrb = ({ className }) => (
  <div className={`absolute rounded-full blur-3xl opacity-20 pointer-events-none ${className}`} />
);

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="w-4 h-4 text-violet-400 flex-shrink-0 mt-0.5">
    <path d="M5 13l4 4L19 7" />
  </svg>
);

const SERVICES = [
  {
    id: "local-seo",
    badge: "Rank Where It Counts",
    title: "Local SEO Services Texas",
    desc: "Dominate local search results with location-optimized pages, Google Business Profile management, and citation building. Our local SEO services Texas strategies are built around your specific market — whether you operate in Dallas, Houston, Austin, or across the entire state. We optimize for 'near me' searches, local pack rankings, and geo-targeted keywords that bring ready-to-convert customers directly to your business.",
    features: ["Google Business Profile optimization", "Local citation building & cleanup", "Geo-targeted landing pages", "Near-me search optimization", "Reputation & review management"],
    color: "border-violet-500/30 bg-violet-500/5",
    accent: "text-violet-400",
    badgeColor: "border-violet-500/30 bg-violet-500/10 text-violet-300",
    icon: () => (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-7 h-7">
        <path d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
        <path d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0z" />
      </svg>
    ),
  },
  {
    id: "seo-audit",
    badge: "Know Before You Grow",
    title: "SEO Audit Service Texas",
    desc: "Before we optimize, we diagnose. Our comprehensive SEO audit service Texas covers technical health, crawlability, Core Web Vitals, duplicate content, broken links, schema markup, and on-page keyword alignment. You receive a prioritized action plan with clear recommendations — no jargon, no fluff, just what needs fixing and why. Most clients see measurable ranking improvements within 30–60 days of implementing our audit findings.",
    features: ["Technical SEO health check", "Core Web Vitals analysis", "On-page keyword alignment", "Crawl & indexation audit", "Competitor gap analysis"],
    color: "border-cyan-500/30 bg-cyan-500/5",
    accent: "text-cyan-400",
    badgeColor: "border-cyan-500/30 bg-cyan-500/10 text-cyan-300",
    icon: () => (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-7 h-7">
        <path d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25z" />
      </svg>
    ),
  },
  {
    id: "affordable-seo",
    badge: "Results Without the Markup",
    title: "Affordable SEO Services Texas",
    desc: "Enterprise-quality SEO shouldn't require an enterprise budget. Our affordable SEO services Texas packages are tailored to your business size, industry, and growth goals. We offer transparent monthly pricing with no hidden fees, no long-term lock-in contracts, and zero vanity metrics. Every dollar is traced directly to rankings, traffic, and qualified leads — making BerryByte the most cost-effective SEO partner for Texas startups and growing businesses.",
    features: ["Transparent monthly pricing", "No long-term contracts required", "ROI-focused reporting", "Scalable packages for any budget", "Dedicated account management"],
    color: "border-emerald-500/30 bg-emerald-500/5",
    accent: "text-emerald-400",
    badgeColor: "border-emerald-500/30 bg-emerald-500/10 text-emerald-300",
    icon: () => (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-7 h-7">
        <path d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" />
      </svg>
    ),
  },
  {
    id: "backlinks",
    badge: "Build Authority That Lasts",
    title: "SEO Backlink Services Texas",
    desc: "Authority matters in search. Our SEO backlink services Texas team builds high-quality, editorial backlinks from industry-relevant websites through white-hat outreach, digital PR, and content partnerships. We avoid link farms and high-risk tactics that trigger Google penalties. Instead, we focus on sustainable authority building that compounds over time — raising your domain rating and pushing your pages above competitors for high-value keywords.",
    features: ["White-hat editorial link building", "Digital PR campaigns", "Niche-relevant outreach", "Competitor backlink analysis", "Toxic link disavow audits"],
    color: "border-amber-500/30 bg-amber-500/5",
    accent: "text-amber-400",
    badgeColor: "border-amber-500/30 bg-amber-500/10 text-amber-300",
    icon: () => (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-7 h-7">
        <path d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
      </svg>
    ),
  },
];

const PROCESS = [
  { step: "01", title: "Discovery & Audit", desc: "We analyze your current rankings, technical health, and competitive landscape to identify the highest-impact opportunities." },
  { step: "02", title: "Strategy & Roadmap", desc: "We build a custom SEO roadmap with prioritized actions mapped to your business goals and timeline." },
  { step: "03", title: "On-Page Optimization", desc: "We optimize meta tags, content structure, internal linking, schema markup, and page speed for every target page." },
  { step: "04", title: "Off-Page & Authority", desc: "We execute backlink outreach, digital PR, and local citations to build domain authority over time." },
  { step: "05", title: "Monitor & Iterate", desc: "We track rankings, traffic, and conversions monthly — continuously refining the strategy to compound results." },
];

const STATS = [
  { value: "3–5×", label: "Avg. organic traffic growth (6 months)" },
  { value: "30–60", label: "Days to first ranking improvements" },
  { value: "100%", label: "White-hat, penalty-safe techniques" },
  { value: "47+", label: "Texas businesses ranked page 1" },
];

export default function SEOServicesPage() {
  useSEO({
    title: "SEO Services in Texas — Local, Affordable & Effective | BerryByte",
    description: "Best SEO services in Texas. Local SEO, technical audits, backlink building & affordable packages for Texas startups and enterprises. Get your free SEO audit today.",
    keywords: "seo services in texas, effective seo services texas, local seo services texas, seo audit service texas, affordable seo services texas, seo backlink services texas, best seo services texas",
    canonical: "https://www.berrybyteinn.com/seo-services",
  });

  return (
    <SharedLayout>
      <div className="relative bg-[#050810] overflow-hidden">
        <GlowOrb className="w-[500px] h-[500px] bg-violet-600 -top-32 -right-32" />
        <GlowOrb className="w-[400px] h-[400px] bg-cyan-600 top-1/2 -left-32" />

        {/* ── Hero ── */}
        <section className="relative pt-36 pb-20 px-6">
          <div className="absolute inset-0 opacity-[0.02]" style={{ backgroundImage: "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)", backgroundSize: "80px 80px" }} />
          <div className="relative max-w-5xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-violet-500/30 bg-violet-500/10 text-violet-300 text-sm font-medium mb-6">
              Texas SEO Agency
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight">
              Best SEO Services in Texas —<br className="hidden sm:block" />
              <span className="bg-gradient-to-r from-violet-400 to-cyan-400 bg-clip-text text-transparent"> Organic Growth That Compounds</span>
            </h1>
            <p className="text-xl text-slate-400 max-w-2xl mx-auto mb-10 leading-relaxed">
              Every Texas business competing online needs more than a great product — it needs to be found.
              BerryByte delivers <strong className="text-slate-300">effective SEO services Texas</strong> businesses trust,
              combining technical engineering with data-driven strategy to turn search engines into your most
              reliable growth channel.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-3.5 rounded-xl bg-gradient-to-r from-violet-600 to-cyan-600 text-white font-semibold hover:opacity-90 transition-opacity">
                Get a Free SEO Audit
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4">
                  <path d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                </svg>
              </Link>
              <a href="#services" className="inline-flex items-center gap-2 px-8 py-3.5 rounded-xl border border-white/10 bg-white/[0.03] text-slate-300 font-semibold hover:bg-white/[0.06] transition-colors">
                View Our Services
              </a>
            </div>
          </div>
        </section>

        {/* ── Stats ── */}
        <section className="relative py-12 border-y border-white/5">
          <div className="max-w-5xl mx-auto px-6">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
              {STATS.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-3xl font-black bg-gradient-to-r from-violet-400 to-cyan-400 bg-clip-text text-transparent mb-1">{s.value}</div>
                  <div className="text-sm text-slate-500">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── Services ── */}
        <section id="services" className="relative py-24 px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl font-black text-white mb-4">
                Our Texas SEO Services
              </h2>
              <p className="text-slate-400 max-w-xl mx-auto">
                From local search dominance to technical audits and authority building — we cover every dimension of search engine optimization.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              {SERVICES.map((svc) => {
                const Icon = svc.icon;
                return (
                  <div key={svc.id} id={svc.id} className={`rounded-2xl border p-8 ${svc.color}`}>
                    <div className="flex items-start gap-4 mb-5">
                      <div className={`p-3 rounded-xl border ${svc.color} ${svc.accent}`}>
                        <Icon />
                      </div>
                      <div>
                        <div className={`inline-flex px-3 py-1 rounded-full text-xs font-medium border mb-2 ${svc.badgeColor}`}>
                          {svc.badge}
                        </div>
                        <h3 className="text-xl font-bold text-white">{svc.title}</h3>
                      </div>
                    </div>
                    <p className="text-slate-400 leading-relaxed mb-5 text-sm">{svc.desc}</p>
                    <ul className="space-y-2">
                      {svc.features.map((f) => (
                        <li key={f} className="flex items-start gap-2 text-sm text-slate-400">
                          <CheckIcon />
                          <span>{f}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* ── Why BerryByte ── */}
        <section className="relative py-20 px-6 border-t border-white/5">
          <div className="max-w-5xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-cyan-500/30 bg-cyan-500/10 text-cyan-300 text-sm font-medium mb-6">
                  Why Choose BerryByte
                </div>
                <h2 className="text-3xl sm:text-4xl font-black text-white mb-6 leading-tight">
                  Effective SEO Services Texas Businesses Trust
                </h2>
                <p className="text-slate-400 leading-relaxed mb-6">
                  As a custom software development agency rooted in Texas, we bring a technical edge most SEO agencies simply lack.
                  We fix crawl issues at the code level, implement structured data in hours not weeks, and optimize Core Web
                  Vitals through actual engineering — not just recommendations handed off to a developer.
                </p>
                <p className="text-slate-400 leading-relaxed mb-8">
                  Our clients see an average of 3–5× organic traffic growth within 6 months of engaging our
                  affordable SEO services Texas team. We report on what matters: rankings, traffic, and revenue — not vanity metrics.
                </p>
                <Link to="/contact" className="inline-flex items-center gap-2 px-7 py-3 rounded-xl bg-gradient-to-r from-violet-600 to-cyan-600 text-white font-semibold hover:opacity-90 transition-opacity text-sm">
                  Start with a Free Audit
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4">
                    <path d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                  </svg>
                </Link>
              </div>
              <div className="space-y-4">
                {[
                  { title: "Technical SEO by Engineers", desc: "We fix Core Web Vitals, structured data, and crawl issues at the source code level — not with workarounds." },
                  { title: "Transparent Reporting", desc: "Monthly reports in plain language: what ranks, what improved, and what we're doing next." },
                  { title: "No Black-Hat Shortcuts", desc: "All our SEO backlink services Texas are white-hat only. No penalties, no shortcuts — just sustainable rankings." },
                  { title: "Industry Specialization", desc: "Deep expertise in SaaS, software, professional services, and B2B companies across the US and Canada." },
                ].map((item) => (
                  <div key={item.title} className="p-5 rounded-xl border border-white/8 bg-white/[0.02]">
                    <h3 className="text-white font-semibold text-sm mb-1">{item.title}</h3>
                    <p className="text-slate-500 text-sm leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ── Process ── */}
        <section className="relative py-20 px-6 border-t border-white/5">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-14">
              <h2 className="text-3xl sm:text-4xl font-black text-white mb-4">Our Proven SEO Process</h2>
              <p className="text-slate-400 max-w-lg mx-auto">
                A repeatable, data-driven framework that delivers ranking improvements for every Texas client.
              </p>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-6">
              {PROCESS.map((p) => (
                <div key={p.step} className="text-center">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-violet-600/20 to-cyan-600/20 border border-violet-500/30 flex items-center justify-center mx-auto mb-4">
                    <span className="text-violet-400 font-black text-sm">{p.step}</span>
                  </div>
                  <h3 className="text-white font-bold text-sm mb-2">{p.title}</h3>
                  <p className="text-slate-500 text-xs leading-relaxed">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── CTA ── */}
        <section className="relative py-24 px-6 border-t border-white/5">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl sm:text-4xl font-black text-white mb-4">
              Ready to Rank Higher in Texas?
            </h2>
            <p className="text-slate-400 text-lg mb-10">
              Start with a free SEO audit. We'll identify exactly where your site is losing rankings and
              build a growth strategy designed for your market.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-10 py-4 rounded-xl bg-gradient-to-r from-violet-600 to-cyan-600 text-white font-bold text-lg hover:opacity-90 transition-opacity"
            >
              Get My Free SEO Audit
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
                <path d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
              </svg>
            </Link>
          </div>
        </section>
      </div>
    </SharedLayout>
  );
}
